import FourDPEducation from "@/components/AthleteProfileEducation/fourDP/FourDPEducation";
import { useSearchParams } from "react-router-dom";

const FourDPEducationPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const isStandAlone = searchParams.has("standAlone");
  const closeOnBack = !!searchParams.get("from");
  return <FourDPEducation isStandAlone={isStandAlone} closeOnBack={closeOnBack} />;
};

export default FourDPEducationPage;
